exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ad-time[data-v-f3db6cf8]{width:400px}.click-events .el-radio[data-v-f3db6cf8]{display:block}.wxApp-from[data-v-f3db6cf8]{width:600px;margin-left:120px;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-f3db6cf8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/advert/newAdvert.vue
// module id = 644
// module chunks = 0